import { FeatureKey } from '~/models/feature';

export interface ChatAssistantViewer {
  isSystemManager: boolean;
  /** The feature keys of the current organization. */
  organizationFeatureKeys: readonly string[];
}

/**
 * System managers always see the chat assistant "Suge". pos-backend gives them a chat token
 * without the feature check. Operators see it only when their organization has the
 * `chat_assistant` feature. Without an agent-api URL, the chat cannot work at all.
 */
export function canSeeChatAssistant(viewer: ChatAssistantViewer, agentApiUrl: string): boolean {
  if (agentApiUrl.trim() === '') return false;
  return viewer.isSystemManager || viewer.organizationFeatureKeys.includes(FeatureKey.ChatAssistant);
}

type ShortcutKey = Pick<
  KeyboardEvent,
  'key' | 'ctrlKey' | 'metaKey' | 'altKey' | 'shiftKey' | 'repeat' | 'isComposing' | 'defaultPrevented'
>;

/**
 * Ctrl+/ opens and closes the panel. Cmd+/ does the same on macOS. A held key repeats the
 * keydown, an IME composition owns the key, and an editor can take the key first. None of them
 * toggles the panel.
 */
export function isChatShortcut(event: ShortcutKey): boolean {
  if (event.repeat || event.isComposing || event.defaultPrevented) return false;
  return event.key === '/' && (event.ctrlKey || event.metaKey) && !event.altKey && !event.shiftKey;
}

/** The shortcut text for the button title. `platform` is `navigator.platform`. */
export function chatShortcutLabel(platform: string): string {
  return /Mac|iPhone|iPad|iPod/.test(platform) ? '⌘/' : 'Ctrl+/';
}
